import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnOptions, GridRowType } from '../../models';

@Component({
  selector: 'app-editable-column',
  templateUrl: './editable-column.component.html',
  styleUrl: './editable-column.component.scss',
})
export class EditableColumnComponent {
  @Input()
  dataItem!: { [key: string]: any } & GridRowType;

  @Input()
  column!: ColumnOptions;

  @Input()
  disabled: boolean = false;
  
  @Input()
  fontSize!: number;

  @Input()
  placeholder: string = '';

  @Output()
  valueChange: EventEmitter<{ dataItem: GridRowType; field: string }> =
    new EventEmitter<{ dataItem: GridRowType; field: string }>();

  onValueChange() {
    this.valueChange.emit({
      dataItem: this.dataItem,
      field: this.column.field,
    });
  }
}
